export const HIERARCHY_TYPES = {
  BLANK: {display: 'None', value: '', showOrder: 1, def: false},
  ENTERPRISE: {display: 'Enterprise', value: 'Enterprise', showOrder: 2, def: false},
  PRIAMARY: {display: 'Primary', value: 'Primary', showOrder: 3, def: false},
  SUB_ACCOUNT: {display: 'Sub-Account', value: 'Sub-Account', showOrder: 4, def: false},
}